import styles from './Loader.module.scss'

export default function LoaderDetailProduct () {
	return (
		<div className={`${styles.animatePulse}`}>
			<div className='flex flex-col gap-6 xl:flex-row mt-6'>
				<div className='xl:w-1/2 bg-grey/100 h-[400px] rounded-xl'>
				</div>
				<div className='xl:w-1/2 bg-grey/40 h-[400px] flex flex-col gap-6 rounded-xl'>
				</div>
			</div>
			<div className='mt-6 mb-12 h-20 bg-grey/40 rounded-xl'>
			</div>
		</div>
	)
}
